import * as types from './CapacityTableActionType';

// Fetch Capacity Table Reports with Pagination
export const fetchCapacityTableReportsRequest = (payload) => ({
    type: types.FETCH_CAPACITY_TABLE_REPORTS_REQUEST,
    payload,
});
export const fetchCapacityTableReportsSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_TABLE_REPORTS_SUCCESS,
    payload,
});
export const fetchCapacityTableReportsFailure = (error) => ({
    type: types.FETCH_CAPACITY_TABLE_REPORTS_FAILURE,
    error,
});


// Notes Edit Actions
export const fetchCapacityNotesEditRequest = (payload) => ({
    type: types.FETCH_CAPACITY_NOTES_EDIT_REQUEST,
    payload,
});
export const fetchCapacityNotesEditSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_NOTES_EDIT_SUCCESS,
    payload,
});
export const fetchCapacityNotesEditFailure = (error) => ({
    type: types.FETCH_CAPACITY_NOTES_EDIT_FAILURE,
    error,
});

// Notes Save Actions
export const fetchCapacityNotesSaveRequest = (payload) => ({
    type: types.FETCH_CAPACITY_NOTES_SAVE_REQUEST,
    payload,
});
export const fetchCapacityNotesSaveSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_NOTES_SAVE_SUCCESS,
    payload,
});
export const fetchCapacityNotesSaveFailure = (error) => ({
    type: types.FETCH_CAPACITY_NOTES_SAVE_FAILURE,
    error,
});

// Delete Capacity Report
export const deleteCapacityReportRequest = (payload) => ({
    type: types.DELETE_CAPACITY_REPORT_REQUEST,
    payload,
});
export const deleteCapacityReportSuccess = (payload) => ({
    type: types.DELETE_CAPACITY_REPORT_SUCCESS,
    payload,
});
export const deleteCapacityReportFailure = (error) => ({
    type: types.DELETE_CAPACITY_REPORT_FAILURE,
    error,
});

// Get All Capacity Table Published Report List Actions
export const getAllCapacityTablePublishedReportListRequest = () => ({
    type: types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_REQUEST,
});
export const getAllCapacityTablePublishedReportListSuccess = (payload) => ({
    type: types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_SUCCESS,
    payload,
});
export const getAllCapacityTablePublishedReportListFailure = (error) => ({
    type: types.GET_ALL_CAPACITY_TABLE_PUBLISHED_REPORT_LIST_FAILURE,
    error,
});

// Enable/Disable Capacity Table Report Actions
export const enableDisableCapacityTableReportRequest = (payload) => ({
    type: types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_REQUEST,
    payload,
});
export const enableDisableCapacityTableReportSuccess = (payload) => ({
    type: types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_SUCCESS,
    payload,
});
export const enableDisableCapacityTableReportFailure = (error) => ({
    type: types.ENABLE_DISABLE_CAPACITY_TABLE_REPORT_FAILURE,
    error,
});

export const getActiveCoverageGapCapacityTableReportRequest = (meta) => ({
    type: types.GET_ACTIVE_COVERAGE_GAP_CAPACITY_TABLE_REPORT_REQUEST,
    meta,
});
export const getActiveCoverageGapCapacityTableReportSuccess = (payload) => ({
    type: types.GET_ACTIVE_COVERAGE_GAP_CAPACITY_TABLE_REPORT_SUCCESS,
    payload,
});
export const getActiveCoverageGapCapacityTableReportFailure = (error) => ({
    type: types.GET_ACTIVE_COVERAGE_GAP_CAPACITY_TABLE_REPORT_FAILURE,
    error,
});

// CoverageGapTool Data Refresh Actions
export const coverageGapToolDataRefreshRequest = () => ({
    type: types.COVERAGE_GAP_TOOL_DATA_REFRESH_REQUEST,
});
export const coverageGapToolDataRefreshSuccess = (payload) => ({
    type: types.COVERAGE_GAP_TOOL_DATA_REFRESH_SUCCESS,
    payload,
});
export const coverageGapToolDataRefreshFailure = (error) => ({
    type: types.COVERAGE_GAP_TOOL_DATA_REFRESH_FAILURE,
    error,
});

// CoverageGapTool Child Data Refresh Actions
export const coverageGapToolChildDataRefreshRequest = () => ({
    type: types.COVERAGE_GAP_TOOL_CHILD_DATA_REFRESH_REQUEST,
});
export const coverageGapToolChildDataRefreshSuccess = (payload) => ({
    type: types.COVERAGE_GAP_TOOL_CHILD_DATA_REFRESH_SUCCESS,
    payload,
});
export const coverageGapToolChildDataRefreshFailure = (error) => ({
    type: types.COVERAGE_GAP_TOOL_CHILD_DATA_REFRESH_FAILURE,
    error,
});

// Get Shift Paste Input Filter Data With Pagination Actions
export const getShiftPasteInputFilterDataWithPaginationRequest = (payload) => ({
    type: types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_REQUEST,
    payload,
});
export const getShiftPasteInputFilterDataWithPaginationSuccess = (payload) => ({
    type: types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_SUCCESS,
    payload,
});
export const getShiftPasteInputFilterDataWithPaginationFailure = (error) => ({
    type: types.GET_SHIFT_PASTE_INPUT_FILTER_DATA_WITH_PAGINATION_FAILURE,
    error,
});

// Get Shift Paste Input Refresh Data With Pagination Actions
export const getShiftPasteInputRefreshDataWithPaginationRequest = (payload) => ({
    type: types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_REQUEST,
    payload,
});
export const getShiftPasteInputRefreshDataWithPaginationSuccess = (payload) => ({
    type: types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_SUCCESS,
    payload,
});
export const getShiftPasteInputRefreshDataWithPaginationFailure = (error) => ({
    type: types.GET_SHIFT_PASTE_INPUT_REFRESH_DATA_WITH_PAGINATION_FAILURE,
    error,
});

// Publish Capacity Table Report Actions
export const publishCapacityTableReportRequest = (payload) => ({
    type: types.PUBLISH_CAPACITY_TABLE_REPORT_REQUEST,
    payload,
});
export const publishCapacityTableReportSuccess = (payload) => ({
    type: types.PUBLISH_CAPACITY_TABLE_REPORT_SUCCESS,
    payload,
});
export const publishCapacityTableReportFailure = (error) => ({
    type: types.PUBLISH_CAPACITY_TABLE_REPORT_FAILURE,
    error,
});

// Get Capacity Table Report Actions
export const getCapacityTableReportRequest = (payload) => ({
    type: types.GET_CAPACITY_TABLE_REPORT_REQUEST,
    payload,
});
export const getCapacityTableReportSuccess = (payload) => ({
    type: types.GET_CAPACITY_TABLE_REPORT_SUCCESS,
    payload,
});
export const getCapacityTableReportFailure = (error) => ({
    type: types.GET_CAPACITY_TABLE_REPORT_FAILURE,
    error,
});

// Get Capacity Table Dropdowns Encore Actions
export const getCapacityTableDropdownsEncoreRequest = (payload) => ({
    type: types.GET_CAPACITY_TABLE_DROPDOWNS_ENCORE_REQUEST,
    payload,
});
export const getCapacityTableDropdownsEncoreSuccess = (payload) => ({
    type: types.GET_CAPACITY_TABLE_DROPDOWNS_ENCORE_SUCCESS,
    payload,
});
export const getCapacityTableDropdownsEncoreFailure = (error) => ({
    type: types.GET_CAPACITY_TABLE_DROPDOWNS_ENCORE_FAILURE,
    error,
});

// Get Active Radiologist Data By ID Actions
export const getActiveRadDataByIdRequest = (payload) => ({
    type: types.GET_ACTIVE_RAD_DATA_BY_ID_REQUEST,
    payload,
});
export const getActiveRadDataByIdSuccess = (payload) => ({
    type: types.GET_ACTIVE_RAD_DATA_BY_ID_SUCCESS,
    payload,
});
export const getActiveRadDataByIdFailure = (error) => ({
    type: types.GET_ACTIVE_RAD_DATA_BY_ID_FAILURE,
    error,
});

// Get Pending Radiologist Data By ID Actions
export const getPendingRadDataByIdRequest = (payload) => ({
    type: types.GET_PENDING_RAD_DATA_BY_ID_REQUEST,
    payload,
});
export const getPendingRadDataByIdSuccess = (payload) => ({
    type: types.GET_PENDING_RAD_DATA_BY_ID_SUCCESS,
    payload,
});
export const getPendingRadDataByIdFailure = (error) => ({
    type: types.GET_PENDING_RAD_DATA_BY_ID_FAILURE,
    error,
});

// Get Offboarding Radiologist Data By ID Actions
export const getOffboardingRadDataByIdRequest = (payload) => ({
    type: types.GET_OFFBOARDING_RAD_DATA_BY_ID_REQUEST,
    payload,
});
export const getOffboardingRadDataByIdSuccess = (payload) => ({
    type: types.GET_OFFBOARDING_RAD_DATA_BY_ID_SUCCESS,
    payload,
});
export const getOffboardingRadDataByIdFailure = (error) => ({
    type: types.GET_OFFBOARDING_RAD_DATA_BY_ID_FAILURE,
    error,
});

// Save Is Excluded Actions
export const saveIsExcludedRequest = (payload) => ({
    type: types.SAVE_IS_EXCLUDED_REQUEST,
    payload,
});
export const saveIsExcludedSuccess = (payload) => ({
    type: types.SAVE_IS_EXCLUDED_SUCCESS,
    payload,
});
export const saveIsExcludedFailure = (error) => ({
    type: types.SAVE_IS_EXCLUDED_FAILURE,
    error,
});

// Unlink Schedule Encore Actions
export const unlinkScheduleEncoreRequest = (payload, meta) => ({
    type: types.UNLINK_SCHEDULE_ENCORE_REQUEST,
    payload,
    meta,
});
export const unlinkScheduleEncoreSuccess = (payload) => ({
    type: types.UNLINK_SCHEDULE_ENCORE_SUCCESS,
    payload,
});
export const unlinkScheduleEncoreFailure = (error) => ({
    type: types.UNLINK_SCHEDULE_ENCORE_FAILURE,
    error,
});

// Relink Schedule Encore Actions
export const relinkScheduleEncoreRequest = (payload, meta) => ({
    type: types.RELINK_SCHEDULE_ENCORE_REQUEST,
    payload,
    meta,
});
export const relinkScheduleEncoreSuccess = (payload) => ({
    type: types.RELINK_SCHEDULE_ENCORE_SUCCESS,
    payload,
});
export const relinkScheduleEncoreFailure = (error) => ({
    type: types.RELINK_SCHEDULE_ENCORE_FAILURE,
    error,
});

// Refresh Schedules Encore Actions
export const refreshSchedulesEncoreRequest = (payload, meta) => ({
    type: types.REFRESH_SCHEDULES_ENCORE_REQUEST,
    payload,
    meta,
});
export const refreshSchedulesEncoreSuccess = (payload) => ({
    type: types.REFRESH_SCHEDULES_ENCORE_SUCCESS,
    payload,
});
export const refreshSchedulesEncoreFailure = (error) => ({
    type: types.REFRESH_SCHEDULES_ENCORE_FAILURE,
    error,
});

// Get Duplicate Schedule Data Actions
export const getDuplicateScheduleDataRequest = (payload) => ({
    type: types.GET_DUPLICATE_SCHEDULE_DATA_REQUEST,
    payload,
});
export const getDuplicateScheduleDataSuccess = (payload) => ({
    type: types.GET_DUPLICATE_SCHEDULE_DATA_SUCCESS,
    payload,
});
export const getDuplicateScheduleDataFailure = (error) => ({
    type: types.GET_DUPLICATE_SCHEDULE_DATA_FAILURE,
    error,
});
// Delete Duplicate Shift Paste Input Data Actions
export const deleteDuplicateShiftPasteInputDataRequest = (payload, meta) => ({
    type: types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_REQUEST,
    payload,
    meta
});
export const deleteDuplicateShiftPasteInputDataSuccess = (payload) => ({
    type: types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_SUCCESS,
    payload,
});
export const deleteDuplicateShiftPasteInputDataFailure = (error) => ({
    type: types.DELETE_DUPLICATE_SHIFT_PASTE_INPUT_DATA_FAILURE,
    error,
});
// Save Radiologist Shift Input Details
export const saveRadiologistShiftInputDetailsRequest = (payload) => ({
    type: types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST,
    payload,
});
export const saveRadiologistShiftInputDetailsSuccess = (payload) => ({
    type: types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS,
    payload,
});
export const saveRadiologistShiftInputDetailsFailure = (error) => ({
    type: types.SAVE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE,
    error,
});

// Delete Shift Input Details Actions
export const deleteShiftInputDetailRequest = (payload, meta) => ({
    type: types.DELETE_SHIFT_INPUT_DETAIL_REQUEST,
    payload,
    meta
});
export const deleteShiftInputDetailSuccess = (payload) => ({
    type: types.DELETE_SHIFT_INPUT_DETAIL_SUCCESS,
    payload,
});
export const deleteShiftInputDetailFailure = (error) => ({
    type: types.DELETE_SHIFT_INPUT_DETAIL_FAILURE,
    error,
});

// Get Shift Input Details By ID Actions
export const getShiftInputDetailsByIdRequest = (payload) => ({
    type: types.GET_SHIFT_INPUT_DETAILS_BY_ID_REQUEST,
    payload,
});
export const getShiftInputDetailsByIdSuccess = (payload) => ({
    type: types.GET_SHIFT_INPUT_DETAILS_BY_ID_SUCCESS,
    payload,
});
export const getShiftInputDetailsByIdFailure = (error) => ({
    type: types.GET_SHIFT_INPUT_DETAILS_BY_ID_FAILURE,
    error,
});

// Get Simulator RPCE With Pagination Actions
export const getSimulatorRPCEWithPaginationRequest = (payload) => ({
    type: types.GET_SIMULATOR_RPCE_WITH_PAGINATION_REQUEST,
    payload,
});
export const getSimulatorRPCEWithPaginationSuccess = (payload) => ({
    type: types.GET_SIMULATOR_RPCE_WITH_PAGINATION_SUCCESS,
    payload,
});
export const getSimulatorRPCEWithPaginationFailure = (error) => ({
    type: types.GET_SIMULATOR_RPCE_WITH_PAGINATION_FAILURE,
    error,
});

// Update Radiologist Shift Input Details Actions
export const updateRadiologistShiftInputDetailsRequest = (payload, meta = {}) => ({
    type: types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_REQUEST,
    payload,
    meta
});
export const updateRadiologistShiftInputDetailsSuccess = (payload) => ({
    type: types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_SUCCESS,
    payload,
});
export const updateRadiologistShiftInputDetailsFailure = (error) => ({
    type: types.UPDATE_RADIOLOGIST_SHIFT_INPUT_DETAILS_FAILURE,
    error,
});

// Update Capacity Table Reducer State
export const updateCapacityTableReducer = (payload) => ({
    type: types.UPDATE_CAPACITY_TABLE_REDUCER,
    payload,
});

// Legacy action creators retained for the legacy grid saga (no longer dispatched by the views)
export const getCapacityTableGridDataWithPaginationRequest = (payload) => ({
    type: types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_REQUEST,
    payload,
});
export const getCapacityTableGridDataWithPaginationSuccess = (payload) => ({
    type: types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_SUCCESS,
    payload,
});
export const getCapacityTableGridDataWithPaginationFailure = (error) => ({
    type: types.GET_CAPACITY_TABLE_GRID_DATA_WITH_PAGINATION_FAILURE,
    error,
});

// Get Capacity Grid Encore Actions (12-week rolling forecast, Live only)
export const getCapacityGridEncoreRequest = (payload) => ({
    type: types.GET_CAPACITY_GRID_ENCORE_REQUEST,
    payload,
});
export const getCapacityGridEncoreSuccess = (payload) => ({
    type: types.GET_CAPACITY_GRID_ENCORE_SUCCESS,
    payload,
});
export const getCapacityGridEncoreFailure = (error) => ({
    type: types.GET_CAPACITY_GRID_ENCORE_FAILURE,
    error,
});

// Get Simulator Encore Actions (net grid, Live/Simulated rows)
export const getSimulatorEncoreRequest = (payload) => ({
    type: types.GET_SIMULATOR_ENCORE_REQUEST,
    payload,
});
export const getSimulatorEncoreSuccess = (payload) => ({
    type: types.GET_SIMULATOR_ENCORE_SUCCESS,
    payload,
});
export const getSimulatorEncoreFailure = (error) => ({
    type: types.GET_SIMULATOR_ENCORE_FAILURE,
    error,
});

// Get Simulator Encore Dropdowns Actions
export const getSimulatorEncoreDropdownsRequest = (payload) => ({
    type: types.GET_SIMULATOR_DROPDOWNS_ENCORE_REQUEST,
    payload,
});
export const getSimulatorEncoreDropdownsSuccess = (payload) => ({
    type: types.GET_SIMULATOR_DROPDOWNS_ENCORE_SUCCESS,
    payload,
});
export const getSimulatorEncoreDropdownsFailure = (error) => ({
    type: types.GET_SIMULATOR_DROPDOWNS_ENCORE_FAILURE,
    error,
});

// Get Access to Demand Encore Actions (Simulator hour-cell modal)
export const getAccessToDemandEncoreRequest = (payload) => ({
    type: types.GET_ACCESS_TO_DEMAND_ENCORE_REQUEST,
    payload,
});
export const getAccessToDemandEncoreSuccess = (payload) => ({
    type: types.GET_ACCESS_TO_DEMAND_ENCORE_SUCCESS,
    payload,
});
export const getAccessToDemandEncoreFailure = (error) => ({
    type: types.GET_ACCESS_TO_DEMAND_ENCORE_FAILURE,
    error,
});

// Draft Capacity Table Report
export const draftCapacityTableReportRequest = (payload) => ({
    type: types.DRAFT_CAPACITY_TABLE_REPORT_REQUEST,
    payload,
});
export const draftCapacityTableReportSuccess = (payload) => ({
    type: types.DRAFT_CAPACITY_TABLE_REPORT_SUCCESS,
    payload,
});
export const draftCapacityTableReportFailure = (error) => ({
    type: types.DRAFT_CAPACITY_TABLE_REPORT_FAILURE,
    error,
});

// Shift Paste Input Duplicate Check Actions
export const shiftPasteInputDuplicateCheckRequest = (payload) => ({
    type: types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_REQUEST,
    payload,
});
export const shiftPasteInputDuplicateCheckSuccess = (payload) => ({
    type: types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_SUCCESS,
    payload,
});
export const shiftPasteInputDuplicateCheckFailure = (error) => ({
    type: types.SHIFT_PASTE_INPUT_DUPLICATE_CHECK_FAILURE,
    error,
});

// Get Capacity Table Refresh Data Actions
export const getCapacityTableRefreshDataRequest = (payload) => ({
    type: types.GET_CAPACITY_TABLE_REFRESH_DATA_REQUEST,
    payload,
});
export const getCapacityTableRefreshDataSuccess = (payload) => ({
    type: types.GET_CAPACITY_TABLE_REFRESH_DATA_SUCCESS,
    payload,
});
export const getCapacityTableRefreshDataFailure = (error) => ({
    type: types.GET_CAPACITY_TABLE_REFRESH_DATA_FAILURE,
    error,
});

// Get Simulator Worklist With Pagination Actions
export const getSimulatorWorklistWithPaginationRequest = (payload) => ({
    type: types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_REQUEST,
    payload,
});
export const getSimulatorWorklistWithPaginationSuccess = (payload) => ({
    type: types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_SUCCESS,
    payload,
});
export const getSimulatorWorklistWithPaginationFailure = (error) => ({
    type: types.GET_SIMULATOR_WORKLIST_WITH_PAGINATION_FAILURE,
    error,
});

// Get Capacity RPCE Details Actions
export const getCapacityRPCEDetailsRequest = (payload) => ({
    type: types.GET_CAPACITY_RPCE_DETAILS_REQUEST,
    payload,
});
export const getCapacityRPCEDetailsSuccess = (payload) => ({
    type: types.GET_CAPACITY_RPCE_DETAILS_SUCCESS,
    payload,
});
export const getCapacityRPCEDetailsFailure = (error) => ({
    type: types.GET_CAPACITY_RPCE_DETAILS_FAILURE,
    error,
});

// Get Capacity Details Actions (for worklist)
export const getCapacityDetailsRequest = (payload) => ({
    type: types.GET_CAPACITY_DETAILS_REQUEST,
    payload,
});
export const getCapacityDetailsSuccess = (payload) => ({
    type: types.GET_CAPACITY_DETAILS_SUCCESS,
    payload,
});
export const getCapacityDetailsFailure = (error) => ({
    type: types.GET_CAPACITY_DETAILS_FAILURE,
    error,
});

// Provider Request (RadRequest) - Get With Pagination Actions
// NOTE: @CurrentPage is the OFFSET (skip) value on the SP, so the component passes (page-1)*perPage.
export const fetchRadRequestsWithPaginationRequest = (payload) => ({
    type: types.FETCH_RAD_REQUESTS_WITH_PAGINATION_REQUEST,
    payload,
});
export const fetchRadRequestsWithPaginationSuccess = (payload) => ({
    type: types.FETCH_RAD_REQUESTS_WITH_PAGINATION_SUCCESS,
    payload,
});
export const fetchRadRequestsWithPaginationFailure = (error) => ({
    type: types.FETCH_RAD_REQUESTS_WITH_PAGINATION_FAILURE,
    error,
});

// Provider Request (RadRequest) - Change Status Actions (Mode: 1 Approve / 2 Simulate / 3 Reject)
export const changeRequestStatusRequest = (payload, meta) => ({
    type: types.CHANGE_REQUEST_STATUS_REQUEST,
    payload,
    meta,
});
export const changeRequestStatusSuccess = (payload) => ({
    type: types.CHANGE_REQUEST_STATUS_SUCCESS,
    payload,
});
export const changeRequestStatusFailure = (error) => ({
    type: types.CHANGE_REQUEST_STATUS_FAILURE,
    error,
});

// Provider Request (RadRequest) - Find Shift Conflicts Actions
export const findShiftConflictsRequest = (payload, meta) => ({
    type: types.FIND_SHIFT_CONFLICTS_REQUEST,
    payload,
    meta,
});
export const findShiftConflictsSuccess = (payload) => ({
    type: types.FIND_SHIFT_CONFLICTS_SUCCESS,
    payload,
});
export const findShiftConflictsFailure = (error) => ({
    type: types.FIND_SHIFT_CONFLICTS_FAILURE,
    error,
});

// Provider Request (RadRequest) - Assign Task Actions (Edit mode Task Name assignment)
export const assignRequestTaskRequest = (payload, meta) => ({
    type: types.ASSIGN_REQUEST_TASK_REQUEST,
    payload,
    meta,
});
export const assignRequestTaskSuccess = (payload) => ({
    type: types.ASSIGN_REQUEST_TASK_SUCCESS,
    payload,
});
export const assignRequestTaskFailure = (error) => ({
    type: types.ASSIGN_REQUEST_TASK_FAILURE,
    error,
});

// Get All Emulator Data Actions (for simulator refresh - worklist)
export const getAllEmulatorDataRequest = (payload) => ({
    type: types.GET_ALL_EMULATOR_DATA_REQUEST,
    payload,
});
export const getAllEmulatorDataSuccess = (payload) => ({
    type: types.GET_ALL_EMULATOR_DATA_SUCCESS,
    payload,
});
export const getAllEmulatorDataFailure = (error) => ({
    type: types.GET_ALL_EMULATOR_DATA_FAILURE,
    error,
});

// Get All Emulator RPCE Data Actions (for simulator refresh - RPCE)
export const getAllEmulatorRPCEDataRequest = (payload) => ({
    type: types.GET_ALL_EMULATOR_RPCE_DATA_REQUEST,
    payload,
});
export const getAllEmulatorRPCEDataSuccess = (payload) => ({
    type: types.GET_ALL_EMULATOR_RPCE_DATA_SUCCESS,
    payload,
});
export const getAllEmulatorRPCEDataFailure = (error) => ({
    type: types.GET_ALL_EMULATOR_RPCE_DATA_FAILURE,
    error,
});

// Get QGenda Tasks And Schedules
export const getQgendaTasksAndSchedulesRequest = (payload) => ({
    type: types.GET_QGENDA_TASKS_SCHEDULES_REQUEST,
    payload,
});
export const getQgendaTasksAndSchedulesSuccess = (payload) => ({
    type: types.GET_QGENDA_TASKS_SCHEDULES_SUCCESS,
    payload,
});
export const getQgendaTasksAndSchedulesFailure = (error) => ({
    type: types.GET_QGENDA_TASKS_SCHEDULES_FAILURE,
    error,
});

// Fetch Capacity Demand Table Data With Pagination (Capacity Table page - Demand Table tab)
export const fetchCapacityDemandTableRequest = (payload) => ({
    type: types.FETCH_CAPACITY_DEMAND_TABLE_REQUEST,
    payload,
});
export const fetchCapacityDemandTableSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_DEMAND_TABLE_SUCCESS,
    payload,
});
export const fetchCapacityDemandTableFailure = (error) => ({
    type: types.FETCH_CAPACITY_DEMAND_TABLE_FAILURE,
    error,
});

// Fetch Demand Input Filter Dropdown List (Capacity Table page - Demand Table tab filter panel)
export const fetchCapacityDemandInputFilterDDListRequest = (payload) => ({
    type: types.FETCH_CAPACITY_DEMAND_INPUT_FILTER_DD_LIST_REQUEST,
    payload,
});
export const fetchCapacityDemandInputFilterDDListSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_DEMAND_INPUT_FILTER_DD_LIST_SUCCESS,
    payload,
});
export const fetchCapacityDemandInputFilterDDListFailure = (error) => ({
    type: types.FETCH_CAPACITY_DEMAND_INPUT_FILTER_DD_LIST_FAILURE,
    error,
});

// Fetch Worklist By Worklist Group Dropdown List (Capacity Table page - Demand Table tab cascade)
export const fetchCapacityWorklistByWorklistGroupDDListRequest = (payload) => ({
    type: types.FETCH_CAPACITY_WORKLIST_BY_WORKLISTGROUP_DD_LIST_REQUEST,
    payload,
});
export const fetchCapacityWorklistByWorklistGroupDDListSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_WORKLIST_BY_WORKLISTGROUP_DD_LIST_SUCCESS,
    payload,
});
export const fetchCapacityWorklistByWorklistGroupDDListFailure = (error) => ({
    type: types.FETCH_CAPACITY_WORKLIST_BY_WORKLISTGROUP_DD_LIST_FAILURE,
    error,
});



